import { Link } from "react-router-dom";
import { ShoppingBasket } from "lucide-react";
import { useBasket } from "@/lib/basket";

export function BasketButton({ testId = "basket-button" }) {
  const { count } = useBasket();
  return (
    <Link to="/basket" data-testid={testId} title="Basket" className="relative p-2 rounded-md text-slate-300 hover:text-white hover:bg-slate-800/60">
      <ShoppingBasket className="h-4 w-4" />
      {count > 0 && <span data-testid={`${testId}-count`} className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full bg-[#F58B23] text-slate-950 text-[10px] font-bold grid place-items-center">{count}</span>}
    </Link>
  );
}
